var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStudentLinked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 38 \\u2013 55",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 4",
    d: "M5 16.289a.751.751 0 01-.75-.75 5.762 5.762 0 014.542-5.623 3.448 3.448 0 01-2.233-3.224 3.446 3.446 0 013.443-3.443 3.446 3.446 0 013.441 3.443 3.449 3.449 0 01-2.232 3.224 5.761 5.761 0 014.541 5.623.751.751 0 01-.75.75z",
    fill: "#10749e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2918",
    fill: "none",
    d: "M0 0h20v20H0z"
  })));
}
export default SvgIconStudentLinked;